import config from './config';

export const initMixpanel = async () => {
  // Content blockers block this chunk or swap it for a stub without a default export. Caught in
  // `.then`, not try/catch, so Vite's preload helper never triggers the stale-chunk reload.
  const mixpanel = await import('mixpanel-browser').then(
    (module) => module.default as typeof module.default | undefined,
    () => undefined,
  );

  mixpanel?.init(config.MIXPANEL_TOKEN, {
    secure_cookie: true,
    cookie_expiration: 10, // days
    persistence: 'localStorage',
    track_pageview: false,
    record_sessions_percent: 10,
    record_min_ms: 5000,
  });
};
